import {breakpoint} from "../utils/breakpoints";
import {gsap, ScrollTrigger} from "../utils/vendor.js";

let mm;

export default class HeroComponent {
    init() {
        mm = gsap.matchMedia();

        mm.add(breakpoint.m, () => {
            document.querySelectorAll(".js-hero").forEach(element => {
                gsap.fromTo(
                    element,
                    {
                        gridTemplateColumns: "20% 30% 50%"
                    },
                    {
                        gridTemplateColumns: "0% 100% 0%",
                        scrollTrigger: {
                            trigger: element,
                            scrub: true,
                            start: "top 60%",
                            end: '+=600',
                        },
                        ease: "none",
                        onComplete: () => ScrollTrigger.refresh()
                    }
                );
            });
        });
    }

    beforeTransition() {
        /**
         * Se visito la home, poi un'altra pagina e poi torno in home,
         * rischio che mm.add() venga eseguita due volte!
         */
        mm?.revert();
    }
}
